import JobProcess from 'models/JobProcess';
import http from 'services/http';

export async function getJobProcess(id: string) {
  return http.get<JobProcess>(`/job_processes/${id}`).then((res) => new JobProcess(res.data));
}
